import { APPOINTMENT_REQUEST_CALENDAR, APPOINTMENT_REQUEST_FORM, CLOSE, EVENT_MESSAGE, MOBILE_SCREEN, SCREEN, HOST_TYPE_ONE_ON_ONE, HOST_TYPE_ROUND_ROBIN, HOST_TYPE_COLLECTIVE } from '../../utils/constants';
import {
    originProcedures,
    providers,
    scheduling,
    setProcedures,
    locations,
    phoneToCall,
    setProviderId,
    setProviders,
    originProviders,
    setProcedureSelectionType,
    form,
    setLocationId,
    setIsInstantQuote,
    setIsBookAppointment,
    pagesDom,
    removeLastPagesDom,
    addPagesDom,
    resetPagesDom,
    setSurgicalOption,
    providerId,
    surgicalOption,
    nameScreenDynamic,
    setSelectedGender,
    leadInfo,
    setSelectedLocation,
    selectedLocation,
    procedures,
    isInInstantQuote,
    showMaleFemalePage,
    setDataSlot,
    showBodyAreaSelection,
    selectedGender,
    redirectUrl,
    eventPayload,
    staffId,
    setAccessToken,
    procedureIdSelected,
    setPatientSelected,
    setSelectedProcedures,
    selectedProcedures,
    setStaffProcedures,
    isDesktopVer,
    appointmentChannelId,
    setProcedureIdSelected,
    setStaffId,
    setProceduresOfAppointmentChannel,
    proceduresOfAppointmentChannel,
    setForm,
    setSelectedLocationId,
    leadTextId,
    hiddenPages,
    widgetOptions,
    isFlowForCalendar,
    setOriginProviders,
    setCustomFields,
    setAppointmentQuestionsCompleted,
} from '../../utils/variables';

import { removeFullName } from '../actions/fullNameActions';
import { removeEmail } from '../actions/emailActions';

import { updateLeadStep } from "../../services/leadServices";

/** Tracks which lead we already sent consult/prebook step with sessionEnded=true for (avoids duplicate consult requests). */
let _sessionEndStepSentForLeadId = null;

/** When true, navigate(THE_END) shows the thank-you / disqualification screen instead of following redirectUrl. */
let _isDisqualified = false;
export function setIsDisqualified(val) { _isDisqualified = val; }

/** Call this when sending the disqualified step so THE_END doesn't also send consult. */
export function setSessionEndStepSentForLeadId(id) {
    _sessionEndStepSentForLeadId = id;
}

function updateBookAppointmentButtonText() {
    const customText = widgetOptions?.find(item => item.type === 'book_appointment')?.button_text;
    const button = document.querySelector('.requestConsult__container .requestConsult__btn .text');
    if (customText && button) {
        button.textContent = customText;
    }
}

/* Components */
import { loadCategories } from '../../views/components/category';
import { loadProcedures } from '../../views/components/procedures';

/* Actions */
import { setTextForServicesButton } from '../actions/browseServicesActions';
import {
    clearCustomFields,
    clearInputsConsult,
    clearLocationDropdown,
    clearProcedureDropdown,
    clearProviderDropdown,
    toggleSelectProcedure,
    toggleSelectProvider,
} from '../actions/consultActions';
import {
    clearAllWidgetIframe,
} from '../actions/iframeActions';
import { removeAllProcedures } from '../actions/procedureActions';
import { removeAllSelectedLocation } from '../actions/locationActions';
import {
    removeAllSelectProvider,
    removeHiddenClassInProvider,
    renderContinueBtn,
} from '../actions/providerActions';
import { toggleLoading, toggleLoadingIframe } from '../actions/loading';
import { clearInputsAskQs } from '../actions/askQuestionActions';
import { loadSelectSearchProcedure } from '../../views/components/selectSearchProcedure';
import { loadProvidersDropdown } from '../../views/components/providersDropdown';
import { resetPageSelectTime } from '../actions/selectTimeActions';
import { resetPageRegisterNewPatientsFormData } from '../actions/registerNewPatientActions';
import { removePhone } from '../actions/phoneActions';
import { preSelectProcedure, removeStyleSurgicalOptionSelected } from './surgicalListeners';
import { selectGenderListeners } from './selectGenderListeners';
import { fetchProcedureByStaff, filterProcedures, handleProviderContinueBtn, handleSelectProvider, providerListeners } from './providersListeners';
import { loadProviderList } from '../../views/pages/providers';
import { renderbodySelectionUI } from '../actions/bodyAreaSelectionAction';
import { bodyAreaSelectionListeners } from './bodyAreaSelectionListeners';
import { patientContinueBtnHandler, patientListeners } from './patientListeners';
import { getProceduresStaffByProcedureIds } from '../../services/procedureServices';
import { handleLocationPage } from './locationListeners';
import { renderStaffInfoHeader } from '../actions/InfoStaffAppointment';
import { renderUILocationCall } from '../actions/locationCallAction';
import { isPageHidden } from '../../utils/checkHiddenPage';
import { loadAllQuestionsFlow } from '../actions/allQuestionsFlow';

export var servicesScreen = '';

export function params(param) {
    // Normalize ?? to ? so form_id is parsed (e.g. /??form_id=xxx)
    const search = (window.location.search || '').replace(/^\?+/, '?');
    const urlParams = new URLSearchParams(search);
    return urlParams.get(param);
}

/** Add event_id to the current URL so refresh/revisit shows the appointment confirmed page. Updates both this frame and the top window when in an iframe (so the address bar reflects event_id). */
export function updateUrlWithEventId(eventId) {
    if (!eventId) return;
    const id = String(eventId);
    try {
        const url = new URL(window.location.href);
        url.searchParams.set('event_id', id);
        window.history.replaceState({}, '', url.toString());
    } catch (_) {}
    if (window.top !== window.self) {
        try {
            const topUrl = new URL(window.top.location.href);
            topUrl.searchParams.set('event_id', id);
            window.top.history.replaceState({}, '', topUrl.toString());
        } catch (_) {}
    }
}

/** Set the action query param (e.g. 'reschedule', 'cancel') so the time-select flow uses the correct endpoint. Preserves event_id, form_id, signature, expires, v. */
export function setActionParam(action) {
    if (!action) return;
    try {
        const url = new URL(window.location.href);
        url.searchParams.set('action', action);
        window.history.replaceState({}, '', url.toString());
    } catch (_) {}
    if (window.top !== window.self) {
        try {
            const topUrl = new URL(window.top.location.href);
            topUrl.searchParams.set('action', action);
            window.top.history.replaceState({}, '', topUrl.toString());
        } catch (_) {}
    }
}

export function refresh() {
    /* Close all opening popup in all services screen */
    document
        .querySelectorAll('.popup__open')
        .forEach((i) => i.classList.remove('popup__open'));

    /* Hide all background showed when popup opening */
    document
        .querySelectorAll('.popup__background')
        .forEach((i) => i.classList.remove('displayed'));

    document
        .querySelectorAll('.move-to-right')
        .forEach((i) => i.classList.remove('move-to-right'));

    /* Turn off all loading */
    toggleLoading(false);
    toggleLoadingIframe(false);

    /* clear all iframe screen */
    clearAllWidgetIframe();

    /* Reset procedures and providers to origin data */
    setProcedures(originProcedures);
    setProviders(originProviders);

    /* Reset data in dropdowns */
    loadSelectSearchProcedure(originProcedures);
    if (providers.length > 1) {
        loadProvidersDropdown(originProviders);
    }

    /* Remove selected providers in providers selection screen */
    removeAllSelectProvider();

    /* Remove selected procedures in all services screen */
    removeAllProcedures();

    /* Remove selected location in Location selection screen */
    removeAllSelectedLocation();

    /* Clear inputs in Request consultation screen*/
    clearInputsConsult();

    /* Clear inputs in ask question screen */
    clearInputsAskQs();

    /* Clear dropdowns in Request consultation screen */
    clearLocationDropdown();
    clearProcedureDropdown();
    clearProviderDropdown();

    /* Clear language dropdown validation state */
    clearLanguageDropdownValidation();

    clearCustomFields();

    removeHiddenClassInProvider();
    setIsInstantQuote(false);

    refreshProvidersStore(false);
    setCustomFields(form?.form?.custom_fields || []);

    document.querySelector('.surgical-option__btn')?.classList.add('disabled');
    removeStyleSurgicalOptionSelected(surgicalOption);
    setSurgicalOption(null);

    document
        .querySelector('.consultSummary__container')
        ?.classList?.remove('show-consult-summary-question');

    document
        .querySelector('.endScreen__container')
        ?.classList?.remove('show-the-end-screen');

    document
        .querySelectorAll('.book-appointment')
        .forEach((i) => i.classList.remove('book-appointment'));
    document
        .querySelectorAll('.ask-question__btn')
        .forEach((i) => (i.textContent = 'Ask a question'));
    document
        .querySelectorAll('.providerScheduling__container .schedule__option')
        .forEach((j) => j.classList.remove('selected'));
    document
        .querySelector('.seeServices__container')
        ?.classList.remove('procedure-in-booking');
    document
        .querySelectorAll('.procedure__price-duration')
        .forEach((j) => j.classList.remove('procedure__price-duration--show'));
    document
        .querySelector('.providers__container')
        ?.classList?.remove('provider-in-booking');
    document.querySelector('.no-preference-provider')?.classList?.add('hidden');

    if (document.querySelector('.phone--input invalid')) {
        document.querySelector('.phone--input invalid').value = '';
    }
    document.querySelector('.phone--input invalid')?.blur();

    if (
        document.querySelector(
            '.requestConsult__container .requestConsult__btn'
        )
    ) {
        document
            .querySelector('.requestConsult__container .requestConsult__btn')
            .classList.remove('disabled');
    }

    if (
        document.querySelector(
            '.requestConsult__container .requestConsult__btn .loader__icon'
        )
    ) {
        document.querySelector(
            '.requestConsult__container .requestConsult__btn .loader__icon'
        ).style.display = 'none';
    }

    document.querySelector('.gender__container .gender--selected')
        ?.classList.remove('gender--selected');
    setSelectedGender(null);

    removeFullName();
    document.querySelector('.email__container .email__valid')?.classList.add('hidden');
    document.querySelector('.email__container .email__invalid')?.classList.add('hidden');

    removeEmail();
    document.querySelector('.fullNames__container .fullName__valid')?.classList.add('hidden');
    document.querySelector('.fullNames__container .fullName__invalid ')?.classList.add('hidden');

    let imagesUploads = document.querySelector('.uploadPhotos__container .imagesUpload');
    if (imagesUploads) {
        imagesUploads.innerHTML = '';
    }

    resetPagesDom();
    setIsBookAppointment(false);
    setDataSlot({});

    setSelectedLocationId(null);
}

function clearLanguageDropdownValidation() {
    const languageDropdowns = [
        '.requestConsult__container [data-form="languageConsult"]',
        '.verifyInformation__container [data-form="languageVerify"]'
    ];

    languageDropdowns.forEach(selector => {
        const formItem = document.querySelector(selector);
        if (formItem) {
            formItem.classList.remove('invalid');
        }
    });
}

function showScreen(className) {
    const element = document.querySelector(className);
    addPagesDom(element);
    pagesDom[pagesDom.length - 1].style.zIndex = (
        parseInt(pagesDom[pagesDom.length - 2].style.zIndex) + 1
    ).toString();
}

const disableScrollWhenBlurInput = () => {
    document.querySelectorAll('input').forEach(input => {
        input.addEventListener('focus', handleFocus);
        input.addEventListener('blur', handleBlur);
    });
}

const handleFocus = () => {
    parent.postMessage(EVENT_MESSAGE.ENABLE_SCROLL, "*");
}

const handleBlur = () => {
    parent.postMessage(EVENT_MESSAGE.DISABLE_SCROLL, "*");
}

export async function navigate(page) {
    const screen = getClassScreen(page);

    /* Show full-screen loading overlay immediately so user doesn't see a previous/random page while transitioning */
    toggleLoading(true);

    try {
        if (MOBILE_SCREEN) {
            disableScrollWhenBlurInput();
        }

        if (form?.disclaimer) {
            const widgetFooter = document.querySelector(`${screen} .widget-footer`)
            const subFooter1 = widgetFooter?.querySelector('.subFooter--1')
            const mainEl = widgetFooter?.closest(".mainMenu__container ") || widgetFooter?.closest(".screen")
            if (mainEl) {
                mainEl?.querySelector('.screen__content')?.style.setProperty('--header-height', `${subFooter1.clientHeight + (90 - 17)}px`)
            }
        }

        if (isDesktopVer || page === SCREEN.NOTFOUND_APPOINTMENT) {
            const container = document?.querySelector(`${screen} .screen__content`)
            container?.style.setProperty('--header-height', '0px')
            if (page !== SCREEN.REQUEST_CONSULT) {
                container?.querySelector('.title__wrapper')?.classList.add("hidden")
            }
            if (!container?.querySelector('.infoStaff')) {
                renderStaffInfoHeader(null, null, screen.replace('.', ''), true)
            }
        }

        await updateStep(page);

        if (page === SCREEN.THE_END && redirectUrl && !_isDisqualified) {
            window.parent.location.href = redirectUrl;

            return;
        }

        if (page === SCREEN.THE_END && _isDisqualified) {
            const msg = form?.appointment_channel?.disqualification_message;
            if (msg) {
                const el = document.querySelector('.endScreen__container .notify-text');
                if (el) el.innerHTML = msg;
            }
        }
        const removeLastSelectOnlyPage = (className) => {
            const lastPage = pagesDom[pagesDom.length - 1];
            if (lastPage?.classList.contains(className)) {
                removeLastPagesDom();
                removeLastSelectOnlyPage(className);
            }
        };

        if (page === SCREEN.SELECT_ONLY_DATE) {
            removeLastSelectOnlyPage('selectOnlyDate__container');
        } else if (page === SCREEN.SELECT_ONLY_TIME) {
            removeLastSelectOnlyPage('selectOnlyTime__container');
        }

        showScreen(screen);
    } finally {
        toggleLoading(false);
    }
}

export async function updateStep(page) {
    if (!leadInfo?.id) {
        return;
    }
    const { collect_patient_information_first_before_scheduling } = form?.appointment_channel || {}

    if (page === SCREEN.UPLOAD_PHOTOS) {
        await updateLeadStep(leadInfo.id, 'pre_upload');
    }

    if (page === SCREEN.APPOINTMENT_CONFIRMED && appointmentChannelId && collect_patient_information_first_before_scheduling) {
        updateLeadStep(leadInfo.id, 'prebook', 'true');
    }

    if (page === SCREEN.THE_END) {
        if (eventPayload && eventPayload?.status === 'request') {
            return;
        }

        // Only send consult/prebook with sessionEnded=true once per lead to avoid duplicate consult requests
        if (_sessionEndStepSentForLeadId === leadInfo.id) {
            return;
        }
        _sessionEndStepSentForLeadId = leadInfo.id;

        const step = appointmentChannelId && collect_patient_information_first_before_scheduling ? 'prebook' : 'consult';

        await updateLeadStep(leadInfo.id, step, 'true');
    }
}

export function goBack(screen) {
    let page = getClassScreen(screen);
    if (pagesDom.length - 2 > 0) {
        pagesDom[pagesDom.length - 2].style.pointerEvents = 'none';
    }
    if (screen === SCREEN.SEE_ALL_SERVICES) {
        document.querySelector('.seeServices__container .category_wrapper').innerHTML = '';
        document.querySelector('.seeServices__container .procedures__container').innerHTML = '';
    }
    document.querySelector(page).style.zIndex = '1';
    document.querySelector(page).willChange = 'auto';
    removeLastPagesDom();
    pagesDom[pagesDom.length - 1].style.pointerEvents = 'auto';

    /* Current screen is menu option screen */
    if (pagesDom.length === 1) {
        refresh();
    }

    switch (screen) {
        case SCREEN.ASK_QUESTION:
            clearInputsAskQs();
            break;
        case SCREEN.REQUEST_CONSULT:
            clearInputsConsult();
            break;
        case SCREEN.SEE_ALL_SERVICES:
            removeAllProcedures();
            setProcedureSelectionType(
                form?.appointment_channel?.selection_type || form.selection_type
            );
            break;
        case SCREEN.SELECT_TIME:
            resetPageSelectTime();
            document
                .querySelector(
                    `.providers__list .provider[data-provider-id="${providerId}"]`
                )
                .click();
            break;
        case SCREEN.SURGICAL:
            document
                .querySelector('.validateDigitsContinue__btn')
                .classList.add('disabled');
            setIsBookAppointment(false);
            break;
        case SCREEN.VALIDATE_DIGITS:
            document.getElementById('validateDigits0').value = '';
            document.getElementById('validateDigits1').value = '';
            document.getElementById('validateDigits2').value = '';
            document.getElementById('validateDigits3').value = '';
            break;
        case SCREEN.REGISTER_NEW_PATIENT:
            resetPageRegisterNewPatientsFormData();
            break;
        case SCREEN.PROVIDERS:
            setProviderId('');
            removeHiddenClassInProvider();
            document.querySelector('.providers__container')?.classList?.remove('provider-in-booking');
            document.querySelector('.no-preference-provider')?.classList?.add('hidden');
            break;
        case SCREEN.SELECT_GENDER:
            setIsInstantQuote(false);
            break;
        case SCREEN.PHONE:
            removePhone();
            break;
        case SCREEN.ALL_QUESTIONS:
            // Clear any question data if needed
            break;
        default:
            break;
    }
}

export function customFeildGoBackAnimationHandler(pageClass) {
    document.getElementById('consult-summary')?.focus();
    document.querySelector(pageClass).style.zIndex = '1';
    removeLastPagesDom();
}

export function getClassScreen(screen) {
    switch (screen) {
        case SCREEN.DASHBOARD:
            return '.mainMenu__container';
        case SCREEN.ASK_QUESTION:
            return '.askQuestion__container';
        case SCREEN.THE_END:
            return '.endScreen__container';
        case SCREEN.REQUEST_CONSULT:
            return '.requestConsult__container';
        case SCREEN.INSTANT_QUOTE:
            return '.widgetScreen__container.instant-quote';
        case SCREEN.PROCEDURE_ELIGIBILITY:
            return '.widgetScreen__container.procedure-eligibility';
        case SCREEN.SEE_ALL_SERVICES:
            return '.seeServices__container';
        case SCREEN.PROVIDERS:
            return '.providers__container';
        case SCREEN.SERVICES_IFRAME:
            return '.widgetScreen__container.see-services';
        case SCREEN.TOP_QUESTION:
            return '.topQuestion__container';
        case SCREEN.LOCATIONS:
            return '.locations__container';
        case SCREEN.CONSULT_SUMMARY:
            return '.consultSummary__container';
        case SCREEN.CONSULT_SCHEDULING:
            return '.consultScheduling__container';
        case SCREEN.PROVIDER_SCHEDULING:
            return '.providerScheduling__container';
        case SCREEN.SERVICE_SUMMARY:
            return '.serviceSummary__container';
        case SCREEN.INTERESTS:
            return '.interests__container';
        case SCREEN.FULL_NAME:
            return '.fullNames__container';
        case SCREEN.EMAIL:
            return '.email__container';
        case SCREEN.PHONE:
            return '.phone__container';
        case SCREEN.INSTANT_QUOTE_SUMMARY:
            return '.instant_quote_summary__container';
        case SCREEN.SURGICAL:
            return '.surgical__container';
        case SCREEN.VALIDATE_DIGITS:
            return '.validateDigits__container';
        case SCREEN.SELECT_TIME:
            return '.selectTime__container';
        case SCREEN.SELECT_ONLY_DATE:
            return '.selectOnlyDate__container';
        case SCREEN.SELECT_ONLY_TIME:
            return '.selectOnlyTime__container';
        case SCREEN.MAIN_MENU:
            return '.mainMenu__container';
        case SCREEN.REGISTER_NEW_PATIENT:
            return '.register-new-patient__container';
        case SCREEN.APPOINTMENT_SUMMARY:
            return '.appointment-summary__container';
        case SCREEN.CARD_COLLECTION:
            return '.card-collection__container';
        case SCREEN.APPOINTMENT_CONFIRMED:
            return '.appointment-confirmed__container';
        case SCREEN.APPOINTMENT_CANCEL:
            return '.appointment-cancel__container';
        case SCREEN.APPOINTMENT_RESCHEDULE:
            return '.appointment-reschedule__container';
        case SCREEN.APPOINTMENT_RESCHEDULE_REASON:
            return '.appointment-reschedule-reason__container';
        case SCREEN.UPLOAD_PHOTOS:
            return '.uploadPhotos__container';
        case SCREEN.SELECT_GENDER:
            return '.gender__container';
        case SCREEN.BODY_AREA_SELECTION:
            return '.bodyAreaSelection__container';
        case SCREEN.VERIFY_INFORMATION:
            return '.verifyInformation__container';
        case SCREEN.ALL_QUESTIONS:
            return '.allQuestions__container';
        case SCREEN.PATIENTS:
            return '.patients__container';
        case SCREEN.NOTFOUND_APPOINTMENT:
            return '.notfound__container';
        case SCREEN.CALLUS:
            return '.callus_container';
        case SCREEN.CATEGORIES:
            return '.categories__container';
        case SCREEN.TEXTAREA_QUESTION:
        case SCREEN.CHECKBOX_QUESTION:
        case SCREEN.TEXT_QUESTION:
        case SCREEN.SELECT_QUESTION:
        case SCREEN.DATE_QUESTION:
        case SCREEN.NUMBER_QUESTION:
        case SCREEN.HEIGHT_QUESTION:
            return `${nameScreenDynamic}`;
        default:
            break;
    }
}

export function pageListeners() {
    /* Select FAQs */
    if (document.querySelector(`#${SCREEN.FAQS}`)) {
        document.querySelector(`#${SCREEN.FAQS}`).onclick = () =>
            openFaqs();
    }

    /* Select Ask A Question */
    if (document.querySelector(`#${SCREEN.ASK_QUESTION}`)) {
        document.querySelector(`#${SCREEN.ASK_QUESTION}`).onclick = () =>
            openAskQuestion();
    }

    /* Select Text Us */
    if (document.querySelector(`#${SCREEN.TEXT_US}`)) {
        document.querySelector(`#${SCREEN.TEXT_US}`).onclick = () =>
            navigate(SCREEN.ASK_QUESTION);
    }

    /* Select instant quote */
    if (document.querySelector(`#${SCREEN.INSTANT_QUOTE}`)) {
        document.querySelector(`#${SCREEN.INSTANT_QUOTE}`).onclick = () =>
            openInstantQuotes(SCREEN.INSTANT_QUOTE);
    }

    /* Select Call */
    if (document.querySelector(`#call.option`)) {
        document.querySelector('#call.option').onclick = () =>
            openCallUs(SCREEN.CALLUS)
    }

    /* Select Book Appointment */
    if (document.querySelector(`#${SCREEN.BOOK_APPOINTMENT}`)) {
        document.querySelector(`#${SCREEN.BOOK_APPOINTMENT}`).onclick = () =>
            openBookAppointment();
    }

    /* Select Custom Option */
    let tempOptionsDom = document.querySelectorAll(`.option`);
    if (tempOptionsDom && tempOptionsDom.length > 0) {
        tempOptionsDom.forEach((item) => {
            if (item.id.includes('custom_option-')) {
                let tempHref = item.querySelector('a').href;
                item.addEventListener('click', () => {
                    const adParams = new URLSearchParams();
                    const advertisingParams = [
                        'gad_source', 'gad_campaignid', 'gbraid', 'gclid',
                        'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content',
                        'fbclid', 'msclkid', 'ttclid'
                    ];

                    try {
                        const parentUrl = new URL(window.parent.location.href);

                        advertisingParams.forEach(param => {
                            if (parentUrl.searchParams.has(param)) {
                                adParams.append(param, parentUrl.searchParams.get(param));
                            }
                        });
                    } catch (error) {
                        try {
                            const currentUrl = new URL(window.location.href);
                            advertisingParams.forEach(param => {
                                if (currentUrl.searchParams.has(param)) {
                                    adParams.append(param, currentUrl.searchParams.get(param));
                                }
                            });
                        } catch (fallbackError) {
                            // 
                        }
                    }

                    if (adParams.toString()) {
                        const customUrl = new URL(tempHref);
                        adParams.forEach((value, key) => {
                            customUrl.searchParams.append(key, value);
                        });
                        tempHref = customUrl.toString();
                    }

                    window.open(tempHref, '_blank');
                });
            }
        });
    }

    navigateGoBack();
    navigateGoBackOneStep();
}

function navigateGoBack() {
    document.querySelectorAll('.screen .back-arrow').forEach((i) => {
        i.onclick = () => goBack(i.getAttribute('data-screen'));
    });
    document.querySelectorAll('.screen .backOneStep__btn').forEach((i) => {
        i.onclick = () => goBack(i.getAttribute('data-screen'));
    });
}

function navigateGoBackOneStep() {
    document.querySelectorAll('.screen .back-to-before-step').forEach((i) => {
        i.onclick = () => goBack(i.getAttribute('data-screen'));
    });
}

export function openInstantQuote() {
    setAccessToken(form.token)
    setIsInstantQuote(true);
    handleCheckProjectCategory();
}

export function openScheduleConsultation() {
    if (locations.length === 1) {
        const locationConsultElement =
            document.querySelector('#locationConsult');
        if (locationConsultElement) {
            locationConsultElement.value = locations[0]?.name;
        }
        setLocationId(locations[0]?.id);
        document
            .querySelector(
                '.requestConsult__container div[data-form="locationConsult"]'
            )
            ?.classList.remove('invalid');

        document
            .querySelector(
                '.requestConsult__container .locationsDropdown__wrapper'
            )
            ?.classList.add('selected');
    }

    if (providers.length === 1) {
        const id = providers[0].id;

        setProviderId(id);

        const newProcedures = providers.find((j) => j.id === id).procedures;

        loadSelectSearchProcedure(newProcedures);

        clearProcedureDropdown();
    }

    if (!scheduling) {
        loadSelectSearchProcedure(procedures);
        toggleSelectProcedure(CLOSE);
        toggleSelectProvider(CLOSE);
        openBookAppointment();
    } else {
        navigate(SCREEN.INSTANT_QUOTE);
    }
}

export function openFaqs() {
    navigate(SCREEN.TOP_QUESTION);
}

export function openAskQuestion() {
    navigate(SCREEN.ASK_QUESTION);
}

export async function openInstantQuotes(screen) {
    refreshProvidersStore(false);
    servicesScreen = screen;
    setIsInstantQuote(true);
    handleCheckProjectCategory();
}

export async function openCallUs(screen) {
    const phoneNumbers = form?.main_phone_number ? [form.main_phone_number] : form?.locations;

    if (phoneNumbers.length > 1) {
        navigate(screen);
        renderUILocationCall();
    } else {
        const phoneNumber = form?.main_phone_number ||
            (form?.locations?.length === 1 ? form?.locations[0]?.phone : null) ||
            phoneToCall;
        window.parent.location.href = `tel:${phoneNumber}`;
    }
}

function shouldShowStaffSelection(hostType, staffCount) {
    switch (hostType) {
        case HOST_TYPE_ONE_ON_ONE:
            return staffCount > 1;
        case HOST_TYPE_ROUND_ROBIN:
        case HOST_TYPE_COLLECTIVE:
            return false;
        default:
            return form?.appointment_channel?.visitor_can_choose_the_staff;
    }
}

function getHostType() {
    return form?.appointment_channel?.host || HOST_TYPE_ONE_ON_ONE;
}

function selectStaffByRoundRobin(staffs) {
    if (!staffs || staffs.length === 0) return null;

    return staffs[0];
}

function selectStaffByCollective(staffs) {
    if (!staffs || staffs.length === 0) return null;

    return staffs;
}

export function directToAllServices(button, procedures) {
    setTextForServicesButton(button);

    loadCategories(procedures);
    loadProcedures(procedures);

    if (isBookAppointment) {
        const enableCategorySelection = form?.appointment_channel?.enable_category_selection;

        if (enableCategorySelection && procedures.length > 1) {
            const filteredCategories = categories.filter((category) =>
                isHasProcedureBelongToCategory(category, procedures)
            );

            if (filteredCategories.length > 0) {
                loadCategoryList(filteredCategories);
                categorySelectionListeners();
                navigate(SCREEN.CATEGORIES);
                return;
            }
        }
    }

    navigate(SCREEN.SEE_ALL_SERVICES);
}

export async function openBookAppointment() {
    // Respect API appointment_request_type "form" so consult request + consult_request_fields are shown
    const apiRequestType = form.appointment_request_type;
    let appointmentRequestType = apiRequestType === APPOINTMENT_REQUEST_FORM
        ? APPOINTMENT_REQUEST_FORM
        : (appointmentChannelId ? APPOINTMENT_REQUEST_CALENDAR : apiRequestType);
    if (appointmentRequestType === APPOINTMENT_REQUEST_CALENDAR) {
        const fields = form?.appointment_channel?.qualification_form?.custom_fields || [];
        setCustomFields(fields);
    }
    setAppointmentQuestionsCompleted(false);
    refreshProvidersStore(appointmentRequestType === APPOINTMENT_REQUEST_CALENDAR);
    const lengthServiceType = Object.keys(form.service_types).length;
    setIsBookAppointment(true);
    setAccessToken(form.token)
    const staffsOfAppointmentChannel = form?.appointment_channel?.staffs?.filter(staff => staff?.online_booking);
    const { collect_patient_information_first_before_scheduling, procedures: proceduresCalendar, location, staffs } = form?.appointment_channel || {};
    if (form?.appointment_channel?.procedures?.length) {
        const proceduresOnlineBooking = form?.appointment_channel?.procedures?.filter(p => p?.online_booking);
        setProceduresOfAppointmentChannel(proceduresOnlineBooking);

        if (appointmentChannelId && proceduresOnlineBooking?.length > 1) {
            setProcedures(proceduresOnlineBooking)
        }
    }

    if (appointmentRequestType === APPOINTMENT_REQUEST_FORM) {
        updateBookAppointmentButtonText();
    }

    if (Object.keys(proceduresCalendar).length) {
        const values = Object.values(proceduresCalendar)
        const proceduresOnlineBooking = values?.filter(p => p?.online_booking)
        setProceduresOfAppointmentChannel(proceduresOnlineBooking)

        setForm(
            {
                ...form,
                appointment_channel: {
                    ...form?.appointment_channel,
                    procedures: Object.values(proceduresCalendar)
                }
            }
        )

        if (appointmentChannelId && proceduresOnlineBooking?.length > 1) {
            setProcedures(proceduresOnlineBooking)
        }
    }

    if (appointmentChannelId && (!proceduresOfAppointmentChannel?.length || !staffsOfAppointmentChannel?.length)) {
        navigate(SCREEN.NOTFOUND_APPOINTMENT)
        return;
    }

    const hostType = getHostType();
    if (appointmentChannelId && staffsOfAppointmentChannel?.length > 0) {
        if (hostType === HOST_TYPE_ROUND_ROBIN) {
            const selectedStaff = selectStaffByRoundRobin(staffsOfAppointmentChannel);
            if (selectedStaff) {
                setStaffId(selectedStaff.id);
                setProviderId(selectedStaff.id);
            }
        } else if (hostType === HOST_TYPE_COLLECTIVE) {
            const selectedStaffs = selectStaffByCollective(staffsOfAppointmentChannel);
            if (selectedStaffs && selectedStaffs.length > 0) {
                setStaffId(selectedStaffs[0].id);
                setProviderId(selectedStaffs[0].id);
            }
        }
    }

    if (lengthServiceType >= 2 || appointmentChannelId) {
        if (staffId) {
            const checkStaffId = form?.staff?.findIndex(staff => staff.id === +staffId);
            if (checkStaffId >= 0 && !appointmentChannelId) {
                await fetchProcedureByStaff(+staffId);
            }
        }
        if ((appointmentRequestType !== APPOINTMENT_REQUEST_CALENDAR) || (appointmentChannelId && collect_patient_information_first_before_scheduling && !leadTextId)) {
            if (procedureIdSelected) {
                preSelectProcedure();
            }
            if (staffId) {
                loadSelectSearchProcedure(procedures);
            }
            const foundProcedure = procedures?.find(i => i?.id === +procedureIdSelected)
            if (foundProcedure) {
                setSurgicalOption(Boolean(foundProcedure.surgical));
            }

            if (collect_patient_information_first_before_scheduling && appointmentChannelId) {
                const staffsOnlineBooking = staffs?.filter(staff => staff?.online_booking)
                if (proceduresCalendar?.length === 1) {
                    setProcedureIdSelected(procedures[0]?.id);
                    preSelectProcedure();
                }
                if (location) {
                    setLocationId(location.id)
                }

                setProviders(staffsOnlineBooking)
                if (staffsOnlineBooking?.length === 1) {
                    setProviderId(staffsOnlineBooking[0]?.id)
                }
                loadSelectSearchProcedure(proceduresCalendar);

                const title = document.querySelector('.requestConsult__container .title__content');
                if (title) {
                    title.textContent = "Enter Patient Information";
                }
            }

            navigate(SCREEN.REQUEST_CONSULT);
        } else {
            if (!staffId && staffsOfAppointmentChannel?.length && appointmentChannelId) {
                setStaffId(staffsOfAppointmentChannel[0]?.id);
            }

            if (!procedureIdSelected && proceduresOfAppointmentChannel && appointmentChannelId && form?.appointment_channel?.procedures?.length === 1) {
                setProcedureIdSelected(proceduresOfAppointmentChannel[0]?.id);
            }

            if (appointmentChannelId) {
                if (locations?.length === 1 || form?.appointment_channel?.location?.id) {
                    const locationId = form?.appointment_channel?.location?.id || locations[0]?.id;
                    setSelectedLocation(locationId);
                    handleLocationPage();
                } else {
                    navigate(SCREEN.LOCATIONS);
                }

                return
            }

            if (staffId && procedureIdSelected) {
                handleProcedureSelection()

            } else {
                if (appointmentChannelId) {
                    patientListeners();
                    if (isPageHidden('patient_page', hiddenPages)) {
                        patientContinueBtnHandler()
                    } else {
                        patientListeners();
                        navigate(SCREEN.PATIENTS);
                    }
                } else {
                    navigate(SCREEN.SURGICAL);
                }
            }
        }

    } else {
        let service = Object.values(form.service_types)[0];

        const hostType = getHostType();
        const staffsOfAppointmentChannel = form?.appointment_channel?.staffs?.filter(staff => staff?.online_booking);
        const staffCount = staffsOfAppointmentChannel?.length || 0;

        if (appointmentChannelId && shouldShowStaffSelection(hostType, staffCount)) {
            if (locations?.length === 1) {
                setSelectedLocation(locations[0]?.id);
                handleLocationPage();
            } else {
                navigate(SCREEN.LOCATIONS);
            }

            return
        }

        if (procedureIdSelected) {
            preSelectProcedure();
        }
        if (staffId) {
            const checkStaffId = form?.staff?.findIndex(staff => staff.id === +staffId);
            if (checkStaffId >= 0) {
                await fetchProcedureByStaff(+staffId);
                loadSelectSearchProcedure(procedures);
            }
        }

        if (service === 'surgical') {
            if (appointmentRequestType === APPOINTMENT_REQUEST_CALENDAR) {
                if (appointmentChannelId) {
                    handleProcedureSelection()
                } else {
                    if (isPageHidden('patient_page', hiddenPages)) {
                        patientContinueBtnHandler()
                    } else {
                        patientListeners();
                        navigate(SCREEN.PATIENTS);
                    }
                }
            } else {
                navigate(SCREEN.REQUEST_CONSULT);
            }
        } else {
            if (appointmentRequestType === APPOINTMENT_REQUEST_CALENDAR) {
                if (appointmentChannelId) {
                    handleProcedureSelection()
                } else {
                    if (isPageHidden('patient_page', hiddenPages)) {
                        patientContinueBtnHandler()
                    } else {
                        patientListeners();
                        navigate(SCREEN.PATIENTS);
                    }

                }
            } else {
                navigate(SCREEN.REQUEST_CONSULT);
            }
        }
    }
}

const handleProcedureSelection = () => {
    let foundProcedure = procedures.find(p => p?.id === +procedureIdSelected)
    if (!foundProcedure && !appointmentChannelId) {
        navigate(SCREEN.SURGICAL);
    } else {
        if (foundProcedure || form?.procedures?.length === 1) {
            foundProcedure = proceduresOfAppointmentChannel[0]
            setSurgicalOption(Boolean(foundProcedure.surgical));
            setPatientSelected(foundProcedure.type);
            setSelectedProcedures([foundProcedure.id]);
        }
        handleClickContinueServiceBtn()
    }
};

const handleClickContinueServiceBtn = async () => {
    if (staffId) {
        const foundProvider = providers?.find(i => i?.id === +staffId)
        const getLocationId = foundProvider?.location_ids?.includes(selectedLocation) || foundProvider?.location_ids[0]
        setSelectedLocation(getLocationId)
        handleSelectProvider(null, +staffId || foundProvider?.id);
        handleProviderContinueBtn()
    } else {
        if (selectedProcedures.length > 0) {
            let res = await getProceduresStaffByProcedureIds(
                selectedProcedures
            );
            setStaffProcedures(res?.data?.data || []);
        }
        if (locations?.length === 1) {
            setSelectedLocation(locations[0]?.id);
            handleLocationPage();
        } else {
            navigate(SCREEN.LOCATIONS);
        }
    }
}

export function doFoCus(targetInput) {
    const fakeInput = document.createElement('input');
    fakeInput.setAttribute('type', 'tel');
    fakeInput.setAttribute('inputmode', 'tel');
    fakeInput.style.position = 'absolute';
    fakeInput.style.opacity = 0;
    fakeInput.style.height = 0;
    fakeInput.style.fontSize = '16px';

    document.body.prepend(fakeInput);
    fakeInput.focus();

    setTimeout(() => {
        targetInput.focus();
        fakeInput.remove();
    }, 400);
}

function handleCheckProjectCategory() {
    if (showMaleFemalePage) {
        selectGenderListeners();
        navigate(SCREEN.SELECT_GENDER);
    } else {
        if (showBodyAreaSelection) {
            renderbodySelectionUI(selectedGender || 'non-binary');
            bodyAreaSelectionListeners();
            navigate(SCREEN.BODY_AREA_SELECTION);

        } else {
            staffId ? handleSelectProvider() : handleCheckProviders();
        }
    }
}

export function handleCheckProviders() {
    if (isInInstantQuote && locations?.length > 1) {
        navigate(SCREEN.LOCATIONS);
        return;
    }

    if (providers.length > 0 && staffId === 0) {
        setSelectedLocation(locations[0].id);
        loadProviderList(
            providers.filter(
                (provider) => provider.location_ids?.includes(selectedLocation)
            )
        );
        renderContinueBtn();
        providerListeners();
        navigate(SCREEN.PROVIDERS);
    } else {
        if (isInInstantQuote) {
            loadCategories(filterProcedures(procedures));
            loadProcedures(filterProcedures(procedures));
            navigate(SCREEN.SEE_ALL_SERVICES);
        }
    }
}

export const goToProviderScheduleLink = () => {
    const ids = form?.appointment_channel?.staffs?.map(i => i.id)
    let listProvider = providers.filter(
        (provider) => ids.includes(provider.id)
    )
    listProvider = listProvider.filter(
        (provider) => provider.location_ids?.includes(selectedLocation)
    )
    loadProviderList(listProvider)
    document
        .querySelector('.providers__container')
        ?.classList?.add('provider-in-booking');
    renderContinueBtn();
    providerListeners();
    document
        .querySelector('.providers__container .providerBack__btn')?.classList?.add('hiden');
    if (appointmentChannelId) {
        document.querySelector('.providers__container .providerContinue__btn ')?.classList?.add('hide');
    }
    navigate(SCREEN.PROVIDERS);
}


export function refreshProvidersStore( isFromAppointmentChannel = false) {
    let providers = [];
    if (isFromAppointmentChannel) {
        providers = form.appointment_channel?.staffs?.filter(provider => provider?.online_booking);
    } else {
        providers = form.staff;
    }
    const sortedProviders = (providers || []).sort((a, b) => Number(a?.order) - Number(b?.order));
    setProviders(Object.values(sortedProviders));
    setOriginProviders(Object.values(sortedProviders));
}